function foldForSearch(text: string): string {
  return text.normalize("NFKC").toLowerCase().replace(/ß/g, "ss")
}

export function matchesSearch(text: string | null | undefined, search: string): boolean {
  if (!search) return true
  return foldForSearch(text ?? "").includes(foldForSearch(search))
}

export function equalsFolded(text: string, other: string): boolean {
  return foldForSearch(text) === foldForSearch(other)
}
